import React, { useContext, useEffect } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";
import { Margin } from "../styles/Emissao";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";
import { AplicaveisBc } from "./RulesEmissaoTributacao";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoIPI = ({ ...props }) => {
  const {
    productIpiSituation,
    setProductIpiSituation,
    productIpiBcValue,
    setProductIpiBcValue,
    productIpiAliquot,
    setProductIpiAliquot,
    productIpiValue,
    setProductIpiValue,
    prodcuctIpiListSituation,
    productIpiCenq,
    setProductIpiCenq,
    productCheckIpiFreight,
    setProductCheckIpiFreight,
    productCheckIpiSafe,
    setProductCheckIpiSafe,
    productCheckIpiOthers,
    setProductCheckIpiOthers,
    productCheckIpiDiscount,
    setProductCheckIpiDiscount,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly, nfeMontageSubtype } = useContext(EmissaoContext);

  const { handleIpiSituation, handleCalcIpi } = useCalculosTributacao();

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleIpiSituation();
  }, [handleIpiSituation, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcIpi();
  }, [handleCalcIpi, nfeMontageSubtype]);

  return (
    <Grid container spacing={2}>
      {AplicaveisBc({
        frete: productCheckIpiFreight,
        setFrete: setProductCheckIpiFreight,
        seguro: productCheckIpiSafe,
        setSeguro: setProductCheckIpiSafe,
        desconto: productCheckIpiDiscount,
        setDesconto: setProductCheckIpiDiscount,
        outras: productCheckIpiOthers,
        setOutras: setProductCheckIpiOthers,
      })}
      <Grow in={true}>
        <Grid item sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item sm={12}>
                  <Select
                    variant="filled"
                    value={productIpiSituation}
                    setValue={setProductIpiSituation}
                    descriptionField="label"
                    label="Situação Tributária IPI"
                    optionsList={prodcuctIpiListSituation}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productIpiCenq}
                    setValue={setProductIpiCenq}
                    size="small"
                    label="Código Enquadramento"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productIpiBcValue}
                    setValue={setProductIpiBcValue}
                    size="small"
                    label="BC do IPI R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productIpiAliquot}
                    setValue={setProductIpiAliquot}
                    size="small"
                    label="Aliquota do IPI"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productIpiValue}
                    setValue={setProductIpiValue}
                    size="small"
                    label="Valor do IPI R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoIPI;
